type SchemaDefinition = Record<string, string>;
export const SCHEMAS: Record<string, SchemaDefinition> = {
  v1: {
    lessonPlans: 'id, index, schoolClass, bookChapter',
    chapters: 'id, chapterNumber, schoolClass',
    gradeSubjects: 'id',
    schoolClassSubjects: 'id',
    schoolClasses: 'id',
    lessonPlanDetail: 'id, index, schoolClass, bookChapter',
    lessonPlanStatus: '++id, [lessonPlan+profile+schoolClass], syncStatus',
    grades: 'id, syncStatus',
    subjects: 'id, syncStatus',
    schoolClassTimetables: '++id, syncStatus',
  },
};

SCHEMAS.v2 = {
  ...SCHEMAS.v1,
  lessonPlans: 'id',
};

SCHEMAS.v3 = {
  ...SCHEMAS.v2,
};

SCHEMAS.v4 = {
  ...SCHEMAS.v3,
  sessions: 'id, label, isCurrent',
};

SCHEMAS.v5 = {
  ...SCHEMAS.v4,
  fluidLessonPlanDetail: 'id, legacyLp, syncStatus',
};
